import React, { useState, useMemo } from 'react';
import { Input, Select, Typography, Space, Card, Divider } from 'antd';
import ArchiveItem from '../../components/Archive';
import { getAllPosts, deletePost, searchPosts } from '../../api/localStorage';
import './index.css';

const { Search } = Input;
const { Option } = Select;
const { Title, Text } = Typography;

const Archives = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedYear, setSelectedYear] = useState('');

  // 获取所有文章并按年份分组
  const archives = useMemo(() => {
    const posts = getAllPosts();
    
    // 按年份分组
    const grouped = {};
    posts.forEach(post => {
      // 修复：确保date字段存在再进行substring操作
      const year = post.date && typeof post.date === 'string' ? post.date.substring(0, 4) : 'Unknown';
      if (!grouped[year]) {
        grouped[year] = [];
      }
      grouped[year].push(post);
    });
    
    // 转换为数组并按年份排序
    return Object.keys(grouped)
      .sort((a, b) => b - a) // 按年份降序排列
      .map(year => ({
        year,
        posts: grouped[year].sort((a, b) => new Date(b.date) - new Date(a.date)) // 按日期降序排列
      }));
  }, []);

  // 获取所有年份
  const years = useMemo(() => {
    return archives.map(item => item.year);
  }, [archives]);

  // 筛选归档数据
  const filteredArchives = useMemo(() => {
    return archives
      .filter(item => {
        // 年份筛选
        if (selectedYear && item.year !== selectedYear) {
          return false;
        }
        return true;
      })
      .map(item => {
        // 搜索词筛选
        if (!searchTerm) {
          return item;
        }
        
        const filteredPosts = item.posts.filter(post => 
          (post.title && post.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (post.excerpt && post.excerpt.toLowerCase().includes(searchTerm.toLowerCase()))
        );
        
        return {
          ...item,
          posts: filteredPosts
        };
      })
      .filter(item => item.posts.length > 0); // 过滤掉没有文章的年份
  }, [archives, searchTerm, selectedYear]);

  const handleSearch = (value) => {
    setSearchTerm(value);
  };

  const handlePostDeleted = (deletedId) => {
    // 重新加载页面以更新数据
    window.location.reload();
  };

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '20px' }}>
      <Card 
        style={{ marginBottom: 24, textAlign: 'center', borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}
        bodyStyle={{ padding: '30px' }}
      >
        <Title level={2} style={{ marginBottom: 8, color: '#1890ff' }}>文章归档</Title>
        <Text type="secondary">浏览和搜索历史文章</Text>
        
        <div style={{ marginTop: 24 }}>
          <Search
            placeholder="搜索文章标题或内容..."
            allowClear
            enterButton="搜索"
            size="large"
            onSearch={handleSearch}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: '100%', maxWidth: 400, marginBottom: 16 }}
          />
        </div>
        
        <div>
          <Space size="large">
            <span style={{ color: '#666' }}>按年份筛选:</span>
            <Select
              style={{ width: 120 }}
              placeholder="选择年份"
              allowClear
              value={selectedYear}
              onChange={(value) => setSelectedYear(value || '')}
              size="middle"
            >
              {years.map(year => (
                <Option key={year} value={year}>{year}</Option>
              ))}
            </Select>
          </Space>
        </div>
      </Card>
      
      <div style={{ marginTop: 16 }}>
        {filteredArchives.length === 0 ? (
          <Card 
            style={{ textAlign: 'center', borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}
            bodyStyle={{ padding: '40px 20px' }}
          >
            <div style={{ fontSize: 16, color: '#888' }}>
              <Text>没有找到匹配的文章</Text>
            </div>
          </Card>
        ) : (
          filteredArchives.map((archive) => (
            <ArchiveItem 
              key={archive.year} 
              archive={archive} 
              onPostDeleted={handlePostDeleted} 
            />
          ))
        )}
      </div>
    </div>
  );
};

export default Archives;